import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuditLogCollection } from '../models/ui/audit-log-collection.model';
import { AuditSdk } from '../sdks/audit.sdk';
import { ExportSdk } from '../sdks/export.sdk';

@Injectable({
	providedIn: 'root'
})
export class AuditManager {
	public auditLogCollection$: Observable<AuditLogCollection>;

	private auditLogCollectionSource: BehaviorSubject<AuditLogCollection> = new BehaviorSubject<AuditLogCollection>(null);

	constructor(
		private auditSdk: AuditSdk,
		private exportSdk: ExportSdk
	) {
		this.auditLogCollection$ = this.auditLogCollectionSource.asObservable();
	}

	public refreshAuditLogs(params: FilterAuditLogParams): void {
		this.auditSdk.get({
			skip: params?.skip || 0,
			top: params?.take || 200,
			orderByDirection: params?.orderByDirection,
			orderByColumn: params?.orderByColumn
		}).subscribe((logs) => this.auditLogCollectionSource.next(logs));
	}

	public exportAuditLogs(): void {
		this.exportSdk.exportAudits().subscribe((url) => {
			window.open(url, '_blank');
		});
	}
}

interface FilterAuditLogParams {
	skip: number;
	take: number;
	orderByColumn?: string;
	orderByDirection?: 'asc' | 'desc';
}



